// Swaps a placeholder image for the real embed on click, so the third-party
// player (and its autoplay param) only loads once the visitor asks for it.
export const videoPlaceholder = (configs) =>
  configs.map(({ el }) => {
    const container = document.querySelector(el);
    if (!container) return null;

    const button = container.querySelector('[data-video-play]');
    const template = container.querySelector('template');
    if (!button || !template) return null;

    button.addEventListener('click', () => {
      container.replaceChildren(template.content.cloneNode(true));
      const iframe = container.querySelector('iframe');
      if (iframe) iframe.focus();
    }, { once: true });

    return container;
  });
